import gql from 'graphql-tag';


export const findTipoDatoHornoForDisp = gql`
    query findTipoDatoHornoForDisp($uuid: String) {
        findTipoDatoHornoForDisp (uuid: $uuid) {
            uuid
            nombre
            nombre_es
            nombre_en
            unidad
            hideCode
    }
}`


export const retrieveOrdersData = gql`
    query retrieveOrdersData($td: String, $first: Int, $offset: Int) {
        retrieveOrdersData (td: $td, first: $first, offset: $offset) {
        _id
        orden
        colada
        clave
        modelo {
            modelo
            acero
            limite_dureza_inferior 
            limite_dureza_superior
            unidad
            tipo_recocido
            ciclo
            temperatura1
            temperatura2
            enfriamiento1
            enfriamiento2
            enfriamientoRI
            temperatura_bano
            escurrido
            piezas_ban_h6
            piezas_ban_h5
            peso_pieza_df
            tempeartura_agua_df
        }
        disp
        dispUUID
        name
        inicio
        fin
        duracion
        bandejas {
            usuario
            usuarioUUID
            cantidad
            fecha
            tipo
            }
        muestras {
            usuario
            usuarioUUID
            valor
            fecha
            unidad
        }
        comentarios {
            usuario
            usuarioUUID
            valor
            fecha
            tipo
        }
        piezas
        kgs
        estado
        bono
    }
}`

export const retrieveSingleOrderData = gql`
    query retrieveSingleOrderData($td: String, $id: String) {
        retrieveSingleOrderData (td: $td, id: $id) {
        _id
        orden
        colada
        clave
        modelo {
                modelo
                acero
                limite_dureza_inferior 
                limite_dureza_superior
                unidad
                tipo_recocido
                ciclo
                temperatura1
                temperatura2
                enfriamiento1
                enfriamiento2
                temperatura_bano
                escurrido
                piezas_ban_h6
                piezas_ban_h5
                peso_pieza_df
                tempeartura_agua_df
            }        
        disp
        dispUUID
        name
        inicio
        fin
        duracion
        bandejas {
            usuario
            usuarioUUID
            cantidad
            fecha
            tipo
            }
        muestras {
            usuario
            usuarioUUID
            valor
            fecha
            unidad
        }
        comentarios {
            usuario
            usuarioUUID
            valor
            fecha
            tipo
        }
        piezas
        kgs
        estado
        bono
    }
}`

export const insertBandejaInOF = gql`
    mutation insertBandeja($_id: String, $cantidad: Int, $fecha: Float, $usuario: String, $usuarioUUID: String, $tipo: String) {
        insertBandeja (_id: $_id, cantidad: $cantidad, fecha: $fecha,  usuario: $usuario, usuarioUUID: $usuarioUUID, tipo: $tipo) {
            cantidad
            fecha
            tipo
            usuario
            usuarioUUID
    }
}`

export const insertMuestra = gql`
    mutation insertMuestra($_id: String, $usuario: String, $usuarioUUID: String, $valor: Int, $unidad: String, $fecha: Float) {
        insertMuestra (_id: $_id, usuario: $usuario, fecha: $fecha,  valor: $valor, usuarioUUID: $usuarioUUID, unidad: $unidad) {
            valor
            fecha
            unidad
            usuario
            usuarioUUID
    }
}`

export const insertComentario = gql`
    mutation insertComentario($_id: String, $usuario: String, $usuarioUUID: String, $valor: String, $tipo: String, $fecha: Float) {
        insertComentario (_id: $_id, usuario: $usuario, fecha: $fecha,  valor: $valor, usuarioUUID: $usuarioUUID, tipo: $tipo) {
            valor
            fecha
            tipo
            usuario
            usuarioUUID
    }
}`


export const deleteArrayElementFromDocument = gql`
    mutation deleteArrayElementFromDocument($td: String, $_id: String, $idx: Int, $arrayName: String) {
        deleteArrayElementFromDocument (td: $td,_id: $_id, idx: $idx, arrayName: $arrayName)
}`

